import { createFileRoute } from '@tanstack/react-router'

import { DebitCard } from '@/containers/DebitCard'
import { orgFeesQueryOptions } from '@/queries/organization'

export const Route = createFileRoute('/_authenticated/account/debit-card')({
  component: DebitCard,
  loader: ({ context: { orgStore, queryClient } }) =>
    queryClient.ensureQueryData(orgFeesQueryOptions(orgStore.getState().orgId)),
})
